import { Controller } from '@hotwired/stimulus';

// Controller for toggling between login and register forms
// Used in booking process step 4 (account)
export default class extends Controller {
  static targets = ['newForm', 'loginForm', 'currentForm', 'newOption', 'loginOption', 'currentOption'];

  connect() {
    this.updateVisibility();
  }

  toggle(event) {
    this.updateVisibility();
  }

  updateVisibility() {
    const selectedValue = this.element.querySelector(
      'input[name*="account_type"]:checked'
    )?.value;

    const isNew = selectedValue === 'new';
    const isLogin = selectedValue === 'login';
    const isCurrent = selectedValue === 'current';

    // Toggle form visibility
    if (this.hasNewFormTarget) {
      this.newFormTarget.classList.toggle('hidden', !isNew);
    }

    if (this.hasLoginFormTarget) {
      this.loginFormTarget.classList.toggle('hidden', !isLogin);
    }

    if (this.hasCurrentFormTarget) {
      this.currentFormTarget.classList.toggle('hidden', !isCurrent);
    }

    // Toggle option styling
    if (this.hasNewOptionTarget) {
      this.newOptionTarget.classList.toggle('bg-white', isNew);
      this.newOptionTarget.classList.toggle('shadow', isNew);
    }

    if (this.hasLoginOptionTarget) {
      this.loginOptionTarget.classList.toggle('bg-white', isLogin);
      this.loginOptionTarget.classList.toggle('shadow', isLogin);
    }

    if (this.hasCurrentOptionTarget) {
      this.currentOptionTarget.classList.toggle('bg-white', isCurrent);
      this.currentOptionTarget.classList.toggle('shadow', isCurrent);
    }
  }
}
